/* eslint-disable react/function-component-definition */
/* Global imports. */
import React from "react";
import {cleanImagePathForImageKit} from "@src/imagekit" 

import LinkWrapper from "../LinkWrapper";
import ImageKit from "../ImageKit";

interface Props {
  title: string;
  intro: any;
  image: string;
  imageAlt: string;
  displayKeyline?: boolean;
  relatedItems?: any;
}

const BannerHeader = ({ title, intro, image, displayKeyline=false, relatedItems, imageAlt }: Props) => {
  const imagePath = cleanImagePathForImageKit(image)
  const imageImageKit = ImageKit({image: `tr:w-1250,pr-true,bl,q-75/${imagePath}`})
  const cssClass = displayKeyline ? "shadow-2xl rounded-md p-8 mt-8" : "content-wrapper"

  return (
    <div className={`${cssClass}`}>
      <section className="relative mb-7">
        {relatedItems && relatedItems.length > 0 && <ul className="py-3 !mb-0 text-center border-y border-y-black !pl-0 !list-none">
        {relatedItems.map((item:any) => <li className="pb-0 sm:inline-block"><LinkWrapper cssClass="!no-underline block mx-4 font-sans" url={`/${item.elements && item.elements.url_slug && item.elements.url_slug.value}`} text={item.elements && item.elements.title && item.elements.title.value} /></li>
        )}
        </ul>
      }
        <img src={imageImageKit} alt={imageAlt} className="w-full"/> 
        {(title || intro && intro !== "<p><br></p>") &&
        <div>
          <div className="max-w-[768px] w-[90%] mx-auto">
            {title && 
            <h1 className="mt-4 text-center">
              {title}
            </h1>
            }
            {intro && intro !== "<p><br></p>" && <div className="font-sans text-center children-font-sans children-article-intro" dangerouslySetInnerHTML={{ __html: intro }} />}
          </div>
        </div>
        }
      </section>
    </div>
  )
};

export default BannerHeader;
